import { render, staticRenderFns } from "./SKUPage.vue?vue&type=template&id=46a09d13"
import script from "./SKUPage.vue?vue&type=script&lang=js"
export * from "./SKUPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports